import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { MadsWordmark } from "./MadsMark";

export const Footer = () => (
  <footer className="border-t border-[rgba(42,33,24,0.07)] bg-[#F0E2C8]" data-testid="site-footer">
    <div className="px-6 sm:px-12 lg:px-20 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <span className="text-3xl">
          <MadsWordmark />
        </span>
        <p className="mt-4 text-sm leading-relaxed text-[#7A6C5A] max-w-xs">
          Shipped worldwide, made to outlive us all.
        </p>
      </div>
      <div>
        <p className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-[#AB9C86] mb-5">
          Navigate
        </p>
        <div className="flex flex-col gap-3">
          <Link to="/collections/everybody-looks" data-testid="footer-link-collection" className="text-sm text-[#7A6C5A] hover:text-[#2A2118] transition-colors">
            Everybody Looks
          </Link>
          <Link to="/special" data-testid="footer-link-special" className="text-sm text-[#7A6C5A] hover:text-[#2A2118] transition-colors">
            Special
          </Link>
          <Link to="/contact" data-testid="footer-link-contact" className="text-sm text-[#7A6C5A] hover:text-[#2A2118] transition-colors">
            Contact
          </Link>
        </div>
      </div>
      <div>
        <p className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-[#AB9C86] mb-5">
          Follow
        </p>
        <a
          href="https://www.instagram.com/madsmade47/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram-link"
          className="inline-flex items-center gap-2 text-sm text-[#7A6C5A] hover:text-[#2A2118] transition-colors"
        >
          <Instagram size={15} />
          @madsmade47
        </a>
      </div>
    </div>
    <div className="border-t border-[rgba(42,33,24,0.07)] px-6 sm:px-12 lg:px-20 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
      <p className="font-mono-accent text-[10px] tracking-[0.25em] text-[#AB9C86] uppercase">
        © 2026 mads. All rights reserved.
      </p>
      <p className="font-mono-accent text-[10px] tracking-[0.25em] text-[#AB9C86] uppercase">
        Every piece ships insured, worldwide
      </p>
    </div>
  </footer>
);
